<template>
  <div v-loading="vt<4 && !alreadyloaded" class="wrapper-dashboard">
    <div v-pre>
      <dashboard wrapper="true" editmode="false" iframe="true" selectedpage="0" public="false" class="flex layout-column" v-pre></dashboard>
    </div>
    <script  type="application/javascript" v-bind:src="platformbase + '/controlpanel/static/js/pages/dashboardMessageHandler.js'"></script>
    <script v-on:load="st=1" v-if="!alreadyloaded" type="application/javascript" v-bind:src="platformbase + '/controlpanel/static/dashboards/scripts/vendor.js'"></script>
    <!-- ADDITIONAL SCRIPTS  
    <script v-if="st>0 && !alreadyloaded" type="application/javascript" v-bind:src="'https://cdn.jsdelivr.net/npm/echarts@5.2.2/dist/echarts.min.js'"></script>-->
   <!-- <script v-if="st>0 && !alreadyloaded" type="application/javascript" v-bind:src="platformbase + '/web/TELCO_RESOURCES/js/vendors/base/vendors.bundle.js'"></script>-->
    <!--<script v-if="st>0 && !alreadyloaded" type="application/javascript" v-bind:src="'https://cdn.jsdelivr.net/npm/vue-carousel@0.18.0/dist/vue-carousel.min.js'"></script>-->
    <script v-if="st>0 && !alreadyloaded" type="application/javascript" v-bind:src="'https://cdnjs.cloudflare.com/ajax/libs/vue-moment/4.1.0/vue-moment.min.js'"></script>   
   <!-- <script v-if="st>0 && !alreadyloaded" type="application/javascript" v-bind:src="'https://unpkg.com/leaflet@1.8.0/dist/leaflet.js'"></script>-->
    <script v-if="st>0 && !alreadyloaded" type="application/javascript" v-bind:src="platformbase + '/controlpanel/static/vendor/element-ui/index.js'"></script>
    <script v-if="st>0 && !alreadyloaded" type="application/javascript" v-bind:src="platformbase + '/controlpanel/static/vendor/element-ui/locale/es.min.js'"></script>
    <script v-if="st>0 && !alreadyloaded" type="application/javascript" v-bind:src="platformbase + '/controlpanel/static/vendor/element-ui/locale/en.min.js'"></script>
    <script v-if="st>0 && !alreadyloaded" type="application/javascript" v-bind:src="platformbase + '/controlpanel/static/dashboards/utils/gadget-form-creator.js'"></script>


    <script v-if="st>0 && !alreadyloaded" type="application/javascript" v-bind:src="'https://cdn.jsdelivr.net/npm/vue-good-table@2.19.1/dist/vue-good-table.min.js'"></script>
    <script v-if="st>0 && !alreadyloaded" type="application/javascript" v-bind:src="'https://cdn.jsdelivr.net/npm/echarts@5.4.0/dist/echarts.min.js'"></script>

   <!--  <script v-if="st>0 && !alreadyloaded" type="application/javascript" v-bind:src="platformbase + '/web/TELCO_RESOURCES/js/scripts.bundle.js'"></script>-->
   <!--  <script v-if="st>0 && !alreadyloaded" type="application/javascript" v-bind:src="platformbase + '/web/TELCO_RESOURCES/js/vendors/datatables/datatables.bundle.js'"></script>-->
   <!--  <script v-if="st>0 && !alreadyloaded" type="application/javascript" v-bind:src="platformbase + '/web/TELCO_RESOURCES/js/TELCO_Controller.js'"></script>    -->
    <script v-if="st>0 && !alreadyloaded" type="application/javascript" v-bind:src="'https://cdnjs.cloudflare.com/ajax/libs/axios/1.1.2/axios.min.js'"></script>
    <!--<script v-if="st>0 && !alreadyloaded" type="application/javascript" v-bind:src="'https://unpkg.com/vue-vis-network@1.0.2/dist/vueVisNetwork.umd.js'"></script>   -->
    <script v-if="st>0 && !alreadyloaded" type="application/javascript" v-bind:src="'https://cdnjs.cloudflare.com/ajax/libs/vue-echarts/6.2.3/index.cjs.min.js'"></script>
    <script v-on:load="st=2" v-if="st>0 && !alreadyloaded" type="application/javascript" v-bind:src="platformbase + '/controlpanel/static/dashboards/gridster.js'"></script>
    <script v-on:load="vt=1" v-if="!alreadyloaded" type="application/javascript" v-bind:src="'/web/ods-cdnn/lib/vue/vue.js'"></script>
    <script v-on:load="vt=2" v-if="vt>0 && !alreadyloaded" type="application/javascript" v-bind:src="'../libs/ods.js'"></script>
    <script v-on:load="vt=3" v-if="vt>1 && !alreadyloaded" type="application/javascript" v-bind:src="'../libs/vue-i18n.js'"></script>
    <script v-on:load="startApp();vt=4;" v-if="(st>1 && vt>2) || alreadyloaded" type="application/javascript" v-bind:src="platformbase + '/controlpanel/static/dashboards/scripts/app.js'"></script>
  </div>
</template>

<script>
export default {
  /* global angular */
  /* eslint no-undef: "error" */
  name: 'dashboard-wrapper',
  props: ['id', 'token', 'model', 'i18n', 'dashboard', 'editmode', 'params', 'platformbase', 'initialDatalink'],
  created: function () {
    this.loaded = false;
    this.getURLParameters = function () {
      var sPageURL = window.location.search.substring(1)
      var sURLVariables = sPageURL.split('&')
      var urlParametersMap = {}
      for (var i = 0; i < sURLVariables.length; i++) {
        if (sURLVariables[i].length > 0) {
          var sParameterName = sURLVariables[i].split('=')
          if (sParameterName[0] !== 'oauthtoken') {
            urlParametersMap[sParameterName[0]] = sParameterName[1]
          }
        }
      }
      return urlParametersMap
    }
    this.isEmptyJson = function (obj) {
      return Object.keys(obj).length === 0 && obj.constructor === Object
    }
    this.setConfig = function (token, params, platformbase, initialDatalink) {
      this.__env = window.__env || {}
      this.__env.socketEndpointConnect = (platformbase ? platformbase : '') + '/dashboardengine/dsengine/solver'
      this.__env.dashboardEngineProtocol = 'websocket'
      this.__env.socketEndpointSend = '/dsengine/solver'
      this.__env.socketEndpointSubscribe = '/dsengine/broker'
      this.__env.endpointControlPanel = (platformbase ? platformbase : '') + '/controlpanel'
      this.__env.endpointDashboardEngine = (platformbase ? platformbase : '') + '/dashboardengine'
      this.__env.dashboardEngineUsername = ''
      this.__env.dashboardEnginePassword = ''
      this.__env.dashboardEngineOauthtoken = token
      this.__env.dashboardEngineLoginRest = '/loginRest'
      this.__env.enableDebug = false
      if (!params) {
        this.__env.urlParameters = this.getURLParameters()
      } else {
        this.__env.urlParameters = params
      }
      // initial datalinks add-on
      if (initialDatalink) {this.__env.initialDatalink = initialDatalink; console.log('WRAPPER INITIAL DATALINK: ' + JSON.stringify(initialDatalink)) }
      this.__env.dashboardEngineBungleMode = true

      angular.module('dashboardFramework').constant('__env', this.__env)
      window.__env = this.__env
      console.info('__env defined manually')
    }
    this.setCacheValue = function (model) {
      angular.module('dashboardFramework').value('cacheBoard', model)
    }
    this.drawError = function (error) {
      document.getElementsByTagName("dashboard")[0].innerHTML = "<div style='padding:15px;background:#fbecec'><div class='no-data-title'>Dashboard Engine Error " + (error.status ? error.status : "") + "</div><div class='no-data-text'>" + (error.config ? "Rest Call: " + error.config.url + ". " : "") + "Detail: " + (error.data ? JSON.stringify(error.data) : error) + "</div></div>";
    }
    this.clearApp = function(parent, subapp) {
      if (typeof angular !== 'undefined'  && typeof subapp !== 'undefined') {
        var ngapp = angular.element(subapp)
        if (ngapp.injector() && ngapp.injector().get('$rootScope')) {
          var $rootScope = ngapp.injector().get('$rootScope');
          ngapp.data("$injector", "")
          $rootScope.$destroy()
          ngapp.empty()
        }
        this.nginst = null;
      }
    }
    this.generateDSApi = function(appRootNode) {
      var scope = this
      var app = angular.element(appRootNode)
      var api = app.isolateScope().vm.api
      api.sendValue = function (gadgetOrigin, key, value) {
        api.sendFilter(gadgetOrigin, key, value, null, "value")
      }
      api.sendFilter = function (gadgetOrigin, key, value, op, typeAction) {
        var jsonModel = {}
        jsonModel[key] = {
          value: value,
          id: gadgetOrigin,
          op: op ? op : "=",
          typeAction: typeAction ? typeAction : "filter"
        }
        app.injector().get('interactionService').sendBroadcastFilter(gadgetOrigin, jsonModel);
      }
      api.ds = {}
      api.ds.get = app.injector().get('datasourceSolverService').get
      api.ds.getOne = app.injector().get('datasourceSolverService').getOne
      api.ds.from = app.injector().get('datasourceSolverService').from
      api.msgApi = window.DSMessageApi
      api.getModel = function(){
        return app.isolateScope().vm.dashboard
      }
      api.setModel = function(dashboard){
        return app.isolateScope().vm.dashboard = dashboard
      }
      api.getDropElementEvent = function(){
        return app.isolateScope().vm.dashboard.gridOptions.emptyCellDropCallback
      }
      api.setDropElementEvent = function(dropElementEvent){
        app.isolateScope().vm.dashboard.gridOptions.emptyCellDropCallback = dropElementEvent
      }
      api.enableEventEdit = function(){
        app.isolateScope().vm.dashboard.gridOptions.eventedit = true
      }
      api.disableEventEdit = function(){
        app.isolateScope().vm.dashboard.gridOptions.eventedit = false
      }
      api.datalink = app.injector().get("interactionService");
      api.params = app.injector().get("urlParamService");
      api.sendParam = app.injector().get("urlParamService").sendBroadcastParam
      api.sendParams = app.injector().get("urlParamService").sendBroadcastParams
      api.gmanagerService = app.injector().get("gadgetManagerService")
      api.favoriteService = app.injector().get("favoriteGadgetService")
      api.setInlineDragType = function(type){
        return app.isolateScope().vm.dashboard.dragGadgetType = type
      }
      api.forceRender = function(){
        app.injector().get("utilsService").forceRender(app.isolateScope())
      }
      // clear cache for dashboard
      api.clearCache = function (dashboard) {
         if (dashboard) {
           // TO-DO: clear only the dashboard id
           scope.setCacheValue({})
         } else {
           // clear All.
           scope.setCacheValue({})
         }

      }
      return api
    }
    this.loadApp = function(id, token, appRootNode, i18n, api, dashboard) {
      var scope = this
      appRootNode.setAttribute("editmode", scope.editmode ? scope.editmode : "false")
      //hide styling button
      var styleSheet = document.styleSheets[document.styleSheets.length-1];

      var ruleNum = styleSheet.cssRules.length;
      if (scope.editmode) {
        styleSheet.insertRule(
            "md-menu-content > md-menu-item:nth-child(2){display:none !important;}",
            ruleNum);
      } else {
        styleSheet.insertRule(
            "md-menu-content > md-menu-item:nth-child(2){display:block !important;}",
            ruleNum);
      }

      if (i18n == true) {
        fetch(this.__env.endpointControlPanel + "/dashboards/i18n/" + dashboard, {
          method: 'get',
          headers: new Headers({
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json'
          })
        }).then(function (res) {
          if (res && res.status == 401) {
            res.config = {
              url: this.__env.endpointControlPanel + "/dashboards/i18n/" + dashboard
            }
            res.data = res.statusText
            throw res
          }
          return res.json()
        }).then(
          function (i18n) {
            scope.__env.i18njson = i18n
            if (!scope.nginst) {
              scope.nginst = angular.bootstrap(angular.element(appRootNode), ['dashboardFramework'])
            }
            scope.api = scope.generateDSApi(appRootNode)
            if (!window.DSApi) {
              window.DSApi = {}
            }
            window.DSApi[id] = {}
            window.DSApi[id].api = scope.api

            window.i18n = new VueI18n({
              locale: "ES",
              fallbackLocale: 'EN',
              // link messages with internacionalization json on controlpanel
              messages: __env.i18njson.languages
            });
          })
      }
      else {

        if (typeof i18n !== 'undefined') {
          scope.__env.i18njson = i18n
        }
        if (!scope.nginst) {
          scope.nginst = angular.bootstrap(angular.element(appRootNode), ['dashboardFramework'])
        }
        scope.api = scope.generateDSApi(appRootNode)
        if (!window.DSApi) {
          window.DSApi = {}
        }
        window.DSApi[id] = {}
        window.DSApi[id].api = scope.api
      }
    }
  },
  mounted: function () {
    var app = this
    var baseop = this.platformbase
    // ADDITIONAL HEADER LIBS AND NEEDED LIBS
    var HeaderLibs = [
      {name: 'Poppins', link: 'https://fonts.googleapis.com/css2?family=Poppins:wght@100;400;600&display=swap', type: 'CSS', order: 1, loadOnly: [], loaded: false},
      {name: 'Dashboard Vendor', link: baseop + '/controlpanel/static/dashboards/styles/vendor.css', type: 'CSS', order: 2, loadOnly: [], loaded: false},
      {name: 'Gridster', link: baseop + '/controlpanel/static/dashboards/gridster.css', type: 'CSS', order: 3, loadOnly: [], loaded: false},
      {name: 'Dashboard App', link: baseop + '/controlpanel/static/dashboards/styles/app.css', type: 'CSS', order: 4, loadOnly: [], loaded: false},
     
     /* {name: 'Vendors Resources', link: baseop + '/web/TELCO_RESOURCES/js/vendors/base/vendors.bundle.css', type: 'CSS', order: 6, loadOnly: [], loaded: false},
      {name: 'Styles Resources', link: baseop + '/web/TELCO_RESOURCES/css/style.bundle.css', type: 'CSS', order: 7, loadOnly: [], loaded: false},            
      {name: 'Datatable Resources', link: baseop + '/web/TELCO_RESOURCES/js/vendors/datatables/datatables.bundle.css',  type: 'CSS', order: 10, loadOnly: [], loaded: false},*/
      {name: 'Gadget Form', link: baseop + '/controlpanel/static/dashboards/utils/gadget-form-creator.css', type: 'CSS', order: 11, loadOnly: [], loaded: false},
      {name: 'Gadget Theme', link: baseop + '/controlpanel/static/vendor/element-ui/theme-chalk/index.css', type: 'CSS', order: 12, loadOnly: [], loaded: false},
      {name: 'Moment', link: 'https://cdn.jsdelivr.net/momentjs/latest/moment.min.js', joint: [], type: 'JS', order: 13, loadOnly: [], loaded: false},     
      {name: 'good table', link: 'https://cdn.jsdelivr.net/npm/vue-good-table@2.19.1/dist/vue-good-table.css', joint: [], type: 'CSS', order: 15, loadOnly: [], loaded: false}
    ]

    // MOUNT CSS FX
    var mountCSS = function (name, link) {
      if (!link) { console.log('Wrapper Header Libs: CSS ', name, ' skipped.'); return false }
      let l  = document.createElement('link')
      l.rel  = 'stylesheet'
      l.type = 'text/css'      
      l.href = link
      document.head.appendChild(l)
      console.log('Wrapper Header Libs: CSS ', name, ' file is loaded')
    }   
    
    // MOUNTING DYNAMICAL NEEDED LIBS (CSS, JS) IN DASHBOARD WRAPPER COMPONENT not dependant
    var item = {}    
    var libs =  HeaderLibs.sort(function(a, b) { return a.order - b.order })
    for (var i = 0; i < libs.length; i++ ) {
      item = libs[i]
      if (item.loaded === true) { continue }
      if (item.type === 'CSS') {
        // MOUNT CSS
        mountCSS(item.name, item.link)
      } else if (item.type === 'JS') {
        // MOUNT JS
        var theItem = item.joint
        var theParent = item.link
        this.$loadScript(item.link).then(() =>{ console.log('Wrapper Header Libs: JS ', item.name, ' file is loaded') })
      }
    }
    
    // leaflet setup
    // window.L18 = L    
         
    if(window.DSApi) {
      this.startApp()
    }
  },
  watch: {
    dashboard: function (newVal) { // watch it
      var parent = this.$el
      var subapp = this.$el.getElementsByTagName("dashboard")[0]
      this.clearApp(parent, subapp)
      subapp.id = this.dashboard
      if ((this.st>1 && this.vt>1) || this.alreadyloaded) {
        this.setConfig(this.token, this.params, this.platformbase, this.initialDatalink) // agrego initial
        this.loadApp(this.id, this.token, subapp, this.i18n, this.api, newVal)
      }

    },
    params: function (newVal) { // watch it
      var parent = this.$el
      var subapp = this.$el.getElementsByTagName("dashboard")[0]
      this.clearApp(parent, subapp)
      subapp.id = this.dashboard
      this.setConfig(this.token, this.params, this.platformbase, this.initialDatalink)
      if ((this.st>1 && this.vt>1) || this.alreadyloaded) {
        this.loadApp(this.id, this.token, subapp, this.i18n, this.api, newVal)
      }
    },
    initialDatalink: function (newVal) { // watch it
      console.log('initialDatalink updated watch in wrapper to: ', JSON.stringify(newVal))
      if ((newVal.constructor === Object && Object.entries(newVal).length > 0)) {
        this.setConfig(this.token, this.params, this.platformbase, newVal)
      }

    }
  },
  beforeDestroy: function () {
    this.clearApp(this.$el, this.$el.getElementsByTagName("dashboard")[0])
  },
  data: function () {
    return {
      st: 0,
      vt: 0,
      alreadyloaded: !!window.DSApi
    }
  },
  methods: {
    startApp: function() {
      this.clearApp()
      var scope = this
      scope.setConfig(scope.token, scope.params, scope.platformbase, scope.initialDatalink)
      if (scope.model) {
        scope.setCacheValue(scope.model)
      }
      var subapp = scope.$el.getElementsByTagName("dashboard")[0]
      subapp.id = scope.dashboard
      scope.loadApp(scope.id, scope.token, subapp, scope.i18n ? scope.i18n == 'true': false, scope.api, scope.dashboard)
    }
  }
}
</script>

<style scoped lang="scss">
.wrapper-dashboard {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: scroll;
}
</style>
